import { apiService } from 'services';
import { announcementActions } from 'store/features';
import { selectAnnouncement } from 'store/selectors';
import { IAnnouncement } from 'types/interfaces';

import store from '../store';

class AnnouncementService {
  public async getAnnouncement() {
    const announcement = selectAnnouncement(store.getState());

    if (announcement.isInitialized) {
      return announcement.announcement;
    }

    const data = await this.getAllAnnouncements();
    store.dispatch(announcementActions.setAnnouncement(data));
    return data;
  }

  private async getAllAnnouncements(): Promise<IAnnouncement | undefined> {
    try {
      return apiService.get('/news', null, undefined, true);
    } catch {}
  }
}

export { AnnouncementService };
export default new AnnouncementService();
